import React, { useEffect, useMemo, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Footer, Header } from "../Components";
import FooterTopBar from "../Components/FooterTopBar";
import { fetchBlog, formatBlogDate, prepareBlogHtml } from "../Services/BlogService";
import "../Assets/Css/HomeCss/BlogDetail.css";

export const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | ready | not-found | error

  useEffect(() => {
    setStatus("loading");
    fetchBlog(slug)
      .then((data) => {
        if (!data || !data.title) throw new Error("Unexpected response");
        setBlog(data);
        setStatus("ready");
        document.title = `${data.title} - Famra Cure`;
      })
      .catch((err) => {
        setStatus(err?.response?.status === 404 ? "not-found" : "error");
      });
  }, [slug]);

  const contentHtml = useMemo(() => (blog ? prepareBlogHtml(blog.content) : ""), [blog]);

  if (status === "not-found" || status === "error") {
    return (
      <>
        <Header />
        <div className="blog-detail-container">
          <div className="blog-not-found">
            <h1>{status === "not-found" ? "Blog Not Found" : "Something went wrong"}</h1>
            <p>
              {status === "not-found"
                ? "The blog article you're looking for doesn't exist."
                : "We couldn't load this article. Please try again later."}
            </p>
            <Link to="/blogs" className="back-to-blogs-btn">
              Back to All Blogs
            </Link>
          </div>
        </div>
        <FooterTopBar />
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="blog-detail-container">
        <div className="blog-detail-wrapper">
          <Link to="/blogs" className="back-link">
            <i className="fa fa-arrow-left"></i> Back to All Blogs
          </Link>

          {status === "loading" ? (
            <div className="space-y-4" aria-label="Loading article">
              <div className="w-full aspect-[16/9] rounded-xl bg-gray-200 animate-pulse"></div>
              <div className="h-8 w-2/3 rounded bg-gray-200 animate-pulse"></div>
              <div className="h-4 w-full rounded bg-gray-200 animate-pulse"></div>
              <div className="h-4 w-5/6 rounded bg-gray-200 animate-pulse"></div>
            </div>
          ) : (
            <>
              <div className="blog-detail-header">
                {blog.image_url && (
                  <img src={blog.image_url} alt={blog.title} className="blog-detail-image" />
                )}
                <h1 className="blog-detail-title">{blog.title}</h1>
                {blog.published_at && (
                  <p className="blog-detail-date">{formatBlogDate(blog.published_at)}</p>
                )}
                {blog.summary && <p className="blog-detail-summary">{blog.summary}</p>}
              </div>

              <div className="blog-detail-content">
                <div dangerouslySetInnerHTML={{ __html: contentHtml }} />
              </div>
            </>
          )}

          <div className="blog-detail-footer">
            <Link to="/blogs" className="back-to-blogs-btn">
              View All Articles
            </Link>
          </div>
        </div>
      </div>
      <FooterTopBar />
      <Footer />
    </>
  );
};

export default BlogDetail;
